/* Rising Sun FPV - shipping estimate by postcode (theme V4.0). See snippets/rs-ship-estimate.liquid.
   Product pages ("item"): prices this product on its own in a separate throwaway cart through Shopify's public
   Storefront API, so the shopper's own cart is never touched. Cart drawer and cart page ("cart"): prices the real cart
   with the theme's cart shipping-rates endpoints. Both return the same live courier rates as checkout (Starshipit). */
(function () {
  'use strict';

  var API = '/api/2025-07/graphql.json';
  var STORE_KEY = 'rsShipZip';
  var MAX_ROWS = 4;
  var STATES = [
    ['ACT', 'Australian Capital Territory', [[200, 299], [2600, 2618], [2900, 2920]]],
    ['NT', 'Northern Territory', [[800, 999]]],
    ['NSW', 'New South Wales', [[1000, 2599], [2619, 2899], [2921, 2999]]],
    ['VIC', 'Victoria', [[3000, 3999], [8000, 8999]]],
    ['QLD', 'Queensland', [[4000, 4999], [9000, 9999]]],
    ['SA', 'South Australia', [[5000, 5999]]],
    ['WA', 'Western Australia', [[6000, 6797], [6800, 6999]]],
    ['TAS', 'Tasmania', [[7000, 7999]]]
  ];

  function stateFor(zip) {
    if (!/^\d{4}$/.test(zip)) return null;
    var n = parseInt(zip, 10);
    for (var i = 0; i < STATES.length; i++) {
      var ranges = STATES[i][2];
      for (var j = 0; j < ranges.length; j++) if (n >= ranges[j][0] && n <= ranges[j][1]) return STATES[i];
    }
    return null;
  }

  function money(amount) {
    var n = Number(amount);
    if (!isFinite(n)) return '';
    if (n === 0) return 'Free';
    return '$' + n.toFixed(2);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function saveZip(zip) { try { window.localStorage.setItem(STORE_KEY, zip); } catch (e) {} }
  function savedZip() { try { return window.localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } }

  /* ---------- product page: one item in a throwaway Storefront API cart ---------- */
  function gql(query, variables, deferred) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': deferred ? 'multipart/mixed; deferSpec=20220824, application/json' : 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
  }

  /* A @defer reply is several JSON parts separated by "--graphql" lines; collect them. */
  function parseParts(text) {
    return text.split('--graphql').map(function (part) {
      var a = part.indexOf('{'), b = part.lastIndexOf('}');
      if (a < 0 || b < a) return null;
      try { return JSON.parse(part.slice(a, b + 1)); } catch (e) { return null; }
    }).filter(Boolean);
  }

  function itemRates(variantId, qty, zip, state) {
    var create = 'mutation($input: CartInput!){ cartCreate(input: $input){ cart { id } userErrors { message } } }';
    var input = {
      lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: qty }],
      buyerIdentity: { countryCode: 'AU' },
      delivery: { addresses: [{ selected: true, address: { deliveryAddress: { zip: zip, provinceCode: state[0], countryCode: 'AU' } } }] }
    };
    return gql(create, { input: input }).then(function (text) {
      var json = JSON.parse(text);
      var cart = json && json.data && json.data.cartCreate && json.data.cartCreate.cart;
      if (!cart) throw new Error('cart');
      var q = 'query($id: ID!){ cart(id: $id){ id ... @defer { deliveryGroups(first: 5, withCarrierRates: true){ nodes { deliveryOptions { title deliveryMethodType estimatedCost { amount } } } } } } }';
      return gql(q, { id: cart.id }, true);
    }).then(function (text) {
      var rates = [];
      parseParts(text).forEach(function (p) {
        var groups = null;
        if (p.incremental) p.incremental.forEach(function (inc) { if (inc.data && inc.data.deliveryGroups) groups = inc.data.deliveryGroups; });
        else if (p.data && p.data.cart && p.data.cart.deliveryGroups) groups = p.data.cart.deliveryGroups;
        if (!groups) return;
        groups.nodes.forEach(function (g) {
          g.deliveryOptions.forEach(function (o) {
            if (o.deliveryMethodType === 'SHIPPING') rates.push({ name: o.title, price: o.estimatedCost && o.estimatedCost.amount });
          });
        });
      });
      return rates;
    });
  }

  /* ---------- cart drawer / cart page: the real cart ---------- */
  function cartRates(zip, state) {
    var qs = 'shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=Australia&shipping_address[province]=' + encodeURIComponent(state[1]);
    var root = (window.routes && window.routes.rootUrlWithoutSlash) || '';
    return fetch(root + '/cart/prepare_shipping_rates.json?' + qs, { method: 'POST', credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 422) throw new Error('address');
        var tries = 0;
        return new Promise(function (resolve, reject) {
          (function poll() {
            fetch(root + '/cart/async_shipping_rates.json?' + qs, { credentials: 'same-origin' })
              .then(function (res) { return res.status === 200 ? res.json() : null; })
              .then(function (json) {
                if (json && json.shipping_rates) return resolve(json.shipping_rates.map(function (r) { return { name: r.name, price: r.price }; }));
                if (++tries > 14) return reject(new Error('timeout'));
                window.setTimeout(poll, 1200);
              })
              .catch(reject);
          })();
        });
      });
  }

  /* ---------- UI ---------- */
  function show(box, html, cls) {
    var out = box.querySelector('[data-rs-ship-out]');
    if (!out) return;
    out.className = 'rs-ship__out' + (cls ? ' ' + cls : '');
    out.innerHTML = html;
  }

  /* The box sits inside the product's own add-to-cart form (under the buy buttons), so read that form first. Searching
     the whole section could find a product card's quick-buy form instead (quick view on collection pages). */
  function currentVariant(box) {
    var form = box.closest('form[action*="/cart/add"]');
    var scope = form || box.closest('.shopify-section') || document;
    var idInput = form ? form.querySelector('[name="id"]') : scope.querySelector('form[action*="/cart/add"] [name="id"]');
    var qtyInput = form ? form.querySelector('[name="quantity"]') : scope.querySelector('form[action*="/cart/add"] [name="quantity"]');
    var id = (idInput && idInput.value) || box.getAttribute('data-variant');
    var qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1);
    return { id: id, qty: qty };
  }

  function run(box) {
    if (box.getAttribute('data-busy') === '1') return;
    var input = box.querySelector('[data-rs-ship-zip]');
    var zip = (input && input.value || '').replace(/\D/g, '');
    var state = stateFor(zip);
    if (!state) {
      show(box, 'Enter a 4-digit Australian postcode.', 'is-error');
      if (input) input.focus();
      return;
    }
    saveZip(zip);
    box.setAttribute('data-busy', '1');
    var btn = box.querySelector('[data-rs-ship-go]');
    if (btn) btn.disabled = true;
    show(box, '<span class="rs-ship__wait">Getting live courier prices for ' + esc(zip) + ' ' + esc(state[0]) + '</span>', 'is-busy');

    var mode = box.getAttribute('data-mode');
    var job;
    if (mode === 'item') {
      var v = currentVariant(box);
      if (!v.id) { job = Promise.reject(new Error('variant')); }
      else job = itemRates(v.id, v.qty, zip, state);
    } else {
      job = cartRates(zip, state);
    }

    job.then(function (rates) {
      rates = rates.filter(function (r) { return r.price != null; }).sort(function (a, b) { return Number(a.price) - Number(b.price); });
      if (!rates.length) {
        show(box, 'No courier price came back for ' + esc(zip) + '. Checkout will show the options for your full address.', 'is-error');
        return;
      }
      /* The cheapest few; the dearer courier options are still offered at checkout. */
      var shown = rates.slice(0, MAX_ROWS), more = rates.length - shown.length;
      var rows = shown.map(function (r) {
        return '<li><span class="rs-ship__name">' + esc(r.name) + '</span><span class="rs-ship__price">' + esc(money(r.price)) + '</span></li>';
      }).join('');
      var extra = more > 0 ? '<p class="rs-ship__more">+ ' + more + ' more courier option' + (more > 1 ? 's' : '') + ' at checkout</p>' : '';
      show(box, '<p class="rs-ship__to">To ' + esc(zip) + ' ' + esc(state[0]) + ':</p><ul class="rs-ship__list" role="list">' + rows + '</ul>' + extra, 'is-done');
    }).catch(function () {
      show(box, 'Couldn’t get prices just now. Checkout will show the options for your address.', 'is-error');
    }).then(function () {
      box.removeAttribute('data-busy');
      if (btn) btn.disabled = false;
    });
  }

  /* Event delegation, because the cart drawer and product section are re-rendered by the theme. */
  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-rs-ship-go]');
    if (!go) return;
    e.preventDefault();
    run(go.closest('[data-rs-ship]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-rs-ship-zip]')) return;
    e.preventDefault(); /* stop the cart form from submitting */
    run(e.target.closest('[data-rs-ship]'));
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-rs-ship-zip]')) return;
    var clean = e.target.value.replace(/\D/g, '').slice(0, 4);
    if (clean !== e.target.value) e.target.value = clean;
  });

  /* Prefill a remembered postcode when someone reaches for the box. */
  document.addEventListener('focusin', function (e) {
    if (!e.target.matches || !e.target.matches('[data-rs-ship-zip]') || e.target.value) return;
    var z = savedZip();
    if (z) e.target.value = z;
  });

  /* A new variant or quantity means the old price may be wrong: clear it. */
  document.addEventListener('variant:changed', function () {
    var boxes = document.querySelectorAll('[data-rs-ship][data-mode="item"]');
    for (var i = 0; i < boxes.length; i++) show(boxes[i], '', '');
  });
})();